import React from "react";

const HelpIcon = ({ onClick }) => (
  <i
    className="fa fa-question-circle ms-2 text-info"
    style={{ cursor: "pointer" }}
    onClick={onClick}
  ></i>
);

export default HelpIcon;
